import React, { useState } from 'react';
import { Store, Barcode, Settings, User, TicketCheck, TicketX, ShoppingBag } from 'lucide-react';
import { Dropdown } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext.js';
import Dashboard from './Dashboard';
import OrderConfirmation from './OrderConfirmation';
import ProductSearch from './ProductSearch';
import './Header.css';

const Header = ({ orderItems = [], onClearOrder, onProductSelect }) => {
  const [showDashboard, setShowDashboard] = useState(false);
  const [showOrderConfirmation, setShowOrderConfirmation] = useState(false);
  const hasItems = orderItems.length > 0;
  const { user, logout } = useAuth();

  const handleHoldOrder = () => {
    if (hasItems) {
      setShowOrderConfirmation(true);
    }
  };

  const handleConfirmOrder = (paymentMethod, orderType = 'sale') => {
    // TODO: Save order to backend with payment method and order type
    console.log('Order confirmed with payment method:', paymentMethod);
    console.log('Order type:', orderType);
    console.log('Order data:', orderItems);

    // Clear order after confirmation
    if (onClearOrder) {
      onClearOrder();
    }
  };

  const handleModifyOrder = () => {
    // Just close the overlay to return to current state
    setShowOrderConfirmation(false);
  };

  const handleCancelOrder = () => {
    if (hasItems && onClearOrder) {
      onClearOrder();
    }
  };

  const handleOpenDashboard = () => {
    setShowDashboard(true);
  };

  const handleCloseDashboard = () => {
    setShowDashboard(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-main">
          <div className="logo">
            <Store className="logo-icon" size={24} color="white" />
            <span className="logo-text">
              <span className="logo-horizonte">Horizonte</span> <span className="logo-cassa">Cassa</span>
            </span>
          </div>

          <div className="search-container">
            <ProductSearch
              onProductSelect={onProductSelect}
              placeholder="Buscar producto..."
            />
          </div>

          <div className="user-options">
            <div className="user-info-container">
              <Dropdown
                menu={{
                  items: [
                    {
                      key: 'username-label',
                      label: (
                        <span style={{ fontWeight: 600, pointerEvents: 'none' }}>
                          {user?.firstName || user?.username || 'Usuario'}
                        </span>
                      ),
                      disabled: true,
                    },
                    { type: 'divider' },
                    {
                      key: 'logout',
                      icon: <LogoutOutlined />,
                      label: 'Cerrar Sesión',
                      onClick: () => logout(),
                    },
                  ],
                }}
                trigger={['click']}
                placement="bottomRight"
              >
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: 6 }}>
                  <UserOutlined style={{ fontSize: 22, color: 'rgba(255,255,255,0.9)' }} />
                  <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: 14, maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {user?.firstName || user?.username || 'Usuario'}
                  </span>
                </div>
              </Dropdown>
            </div>
            <div className="settings-container">
              <Settings
                className="dashboard-icon"
                size={28}
                color="rgba(255, 255, 255, 0.9)"
                onClick={handleOpenDashboard}
                style={{ cursor: 'pointer' }}
              />
              <div className="icon-tooltip">Administración</div>
            </div>
          </div>
        </div>
      </header>

      {showDashboard && <Dashboard onClose={handleCloseDashboard} />}

      {showOrderConfirmation && (
        <OrderConfirmation
          orderData={{
            orderNumber: '#9821',
            userName: 'Usuario A',
            items: orderItems
          }}
          onClose={() => setShowOrderConfirmation(false)}
          onConfirm={handleConfirmOrder}
          onModify={handleModifyOrder}
        />
      )}
    </>
  );
};

export default Header;